import { del, get, patch, post } from 'app/request'
import { pipe } from 'fp-ts/lib/function'
import { UUID } from 'io-ts-types'
import { decodeJson } from 'lib/request'

import { TAuthResult } from './auth.codecs'

export type IssueTokenInput = {
  email: string
  password: string
  clientSecret: string
}

export const issueToken = async (body: IssueTokenInput) => {
  return pipe(
    await post('api/tokens/credentials', {
      body,
    }),
    decodeJson(TAuthResult),
  )
}

export type RefreshTokenInput = {
  clientSecret: string
}

export const refreshToken = async (input: RefreshTokenInput) => {
  return pipe(
    await post('api/tokens/refresh', {
      body: {
        clientSecret: input.clientSecret,
      },
    }),
    decodeJson(TAuthResult),
  )
}

export const signOut = async () => {
  return del('api/tokens/me', {})
}

export type SendResetPasswordLinkInput = {
  email: string
  clientId: string
}

export const sendResetPasswordLink = async (
  input: SendResetPasswordLinkInput,
) => {
  return post('api/confirmations/recovery', {
    body: {
      clientId: input.clientId,
      email: input.email.trim(),
    },
  })
}

export type GetConfirmationInput = {
  requestId: UUID
  hash: string
}

export const getConfirmation = async (input: GetConfirmationInput) => {
  return get('api/confirmations/:id', {
    params: {
      id: input.requestId,
    },
    query: new URLSearchParams({ hash: input.hash }),
  })
}

export type ResetPasswordInput = {
  requestId: UUID
  hash: string
  password: string
}

export const resetPassword = async (input: ResetPasswordInput) => {
  return patch('api/confirmations/recovery/:requestId', {
    body: {
      password: input.password,
    },
    params: {
      requestId: input.requestId,
    },
    query: new URLSearchParams({
      hash: input.hash,
    }),
  })
}

export type ConfirmRegistrationInput = {
  requestId: UUID
  hash: string
}

export const confirmRegistration = async (input: ConfirmRegistrationInput) => {
  return get('api/confirmations/registration', {
    query: new URLSearchParams({
      hash: input.hash,
      id: input.requestId,
    }),
  })
}
